module.exports = __webpack_public_path__ + "static/foundationBg-9b73f8f9b5395ff53c4277b4617c0c5e.jpg";